import { Layout } from 'antd'
import { createStyles } from 'antd-style'

import { system } from '@eastcoal/common/config/system'

import { Breadcrumb } from '@eastcoal/router/components/Breadcrumb'
import { RouterOutlet } from '@eastcoal/router/components/Outlet'
import { EastcoalLogo } from '@eastcoal/shared/components/EastcoalLogo'

import { LayoutFooter } from '../components/Footer'

const useUserLayoutStyles = createStyles(({ token }) => ({
  container: {
    background: token.colorBgContainer
  },
  header: {
    position: 'relative',
    zIndex: token.zIndexPopupBase,
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1,
    background: token.colorBgContainer,
    boxShadow: `0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)`
  },
  headerInner: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  logo: {
    display: 'inline-block',
    paddingInlineEnd: token.padding,
    marginInlineEnd: token.padding,
    borderInlineEnd: `1px solid ${token.colorBorder}`
  },
  breadcrumb: {
    marginBlockEnd: -4,
    padding: 0
  }
}))

export const UserLayout = () => {
  const { styles } = useUserLayoutStyles()

  return (
    <Layout className={styles.container}>
      <Layout.Header className={styles.header}>
        <div className={styles.headerInner}>
          <EastcoalLogo
            className={styles.logo}
            link={system.router.mallBaseUrl}
          />
          <Breadcrumb className={styles.breadcrumb} />
        </div>
      </Layout.Header>
      <Layout.Content>
        <RouterOutlet />
      </Layout.Content>
      <LayoutFooter />
    </Layout>
  )
}
